import strings from '../../../localization';
import { withSnackbar } from 'notistack';
import * as Actions from "../../../actions/Actions";
import { withRouter } from "react-router-dom";
import connect from "react-redux/es/connect/connect";
import { bindActionCreators } from "redux";
import SpecificationReportPage from './SpecificationReportPage';
import { generateBurialBookReport } from '../../../services/report/ReportService';

class BurialBookReport extends SpecificationReportPage {

  getFields() {
    return ['graveyard', 'graveField', 'period'];
  }

  getService() {
    return generateBurialBookReport;
  }

  getFileName() {
    return "2A-glavna-knjiga-sahranjenih";
  }

  getPageTitle() {
    return strings.specificationReports.burialBookTitle;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    changeFullScreen: Actions.changeFullScreen
  }, dispatch);
}

function mapStateToProps({ menuReducers, authReducers, siteDataReducers }) {
  return { menu: menuReducers, auth: authReducers, siteData: siteDataReducers };
}

export default withSnackbar(withRouter(connect(mapStateToProps, mapDispatchToProps)(BurialBookReport)));
